import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {retry, shareReplay, switchMap, timer} from "rxjs";
import {environment} from "../../../environments/environment";
import {CountResponse} from "@shared/types/CountResponse";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BadgeService {
  private readonly API_URL = `${environment.internalAdminServiceBaseUri}`;
  private http: HttpClient = inject(HttpClient);
  constructor() { }

  public getCount(){
    return timer(1, 60000).pipe(
      switchMap(() => this.http.get<CountResponse>(`${this.API_URL}/users/pending/count`)),
      shareReplay(1),
      retry(),
      map(value => value.count)
    )
  }
}
